export { PaymentTermsBadge } from './PaymentTermsBadge';
